import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import { ORGANIZATION_PAYMENT_STATUS } from '../../constants/api';
export const withPlanInfo = (WrappedComponent) => {
    const WithPlanInfo = (props) => {
        const { user, ...rest } = props;
        const haveTrial = user?.user?.plan?.trialExpirationDate && new Date(user.user.plan.trialExpirationDate) > new Date();
        const havePlan = user?.user?.plan?.expirationDate && new Date(user.user.plan.expirationDate) > new Date();
        const validPaymentStatus = user?.user?.plan?.paymentStatus === ORGANIZATION_PAYMENT_STATUS.VALID;
        const isEnterpriseUser = user?.user?.plan?.name === 'Enterprise';
        const isProUser = haveTrial || (havePlan && validPaymentStatus);
        const proPlan = !!(isProUser || isEnterpriseUser);
        return _jsx(WrappedComponent, { ...rest, proPlan: proPlan });
    };
    const mapStateToProps = (state) => ({
        user: state.user,
    });
    return connect(mapStateToProps)(WithPlanInfo);
};
